import { render, staticRenderFns } from "./ProductFormDialog.vue?vue&type=template&id=06aac670"
import script from "./ProductFormDialog.vue?vue&type=script&lang=ts"
export * from "./ProductFormDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports